/**
 * Destaque da área clicada (município, TI, UC…).
 *
 * O gerenciador de camadas cria uma camada de destaque (Z.HIGHLIGHT) e
 * registra a fonte aqui. O conteúdo do popup chama `showHighlight` ao ser
 * montado e desfaz ao ser desmontado — assim o destaque some junto com o popup.
 */
import Feature, { type FeatureLike } from 'ol/Feature';
import Geometry from 'ol/geom/Geometry';
import type VectorSource from 'ol/source/Vector';
import { useVectorStore } from './store';

let target: VectorSource | null = null;

export function attachHighlightSource(source: VectorSource | null): void {
  target = source;
}

/** Destaca a geometria da feature. Retorna a função que remove o destaque. */
export function showHighlight(feature: FeatureLike): () => void {
  const source = target;
  const geometry = feature.getGeometry();
  if (!source || !useVectorStore.getState().highlight || !(geometry instanceof Geometry)) return () => {};
  source.clear();
  const f = new Feature(geometry);
  source.addFeature(f);
  return () => {
    if (source.hasFeature(f)) source.removeFeature(f);
  };
}
